import React from 'react'

interface BrandMarkProps {
  size?: number
  /** On dark surfaces the filled circle lightens so it stays visible. */
  reversed?: boolean
  className?: string
}

/**
 * Two circles meeting: the organiser filled, the volunteer an open ring. Drawn inline
 * rather than loaded as a file so it inherits the page's colour handling and never
 * flashes in late above the fold.
 */
const BrandMark: React.FC<BrandMarkProps> = ({ size = 26, reversed = false, className }) => (
  <svg
    viewBox="0 0 34 34"
    width={size}
    height={size}
    className={className}
    role="img"
    aria-label="RallyShift"
  >
    <circle cx="11" cy="11" r="11" fill={reversed ? '#D97757' : '#C4502E'} />
    <circle
      cx="23"
      cy="23"
      r="9.25"
      fill="none"
      stroke={reversed ? '#F4B79E' : '#DD9070'}
      strokeWidth="3.5"
    />
  </svg>
)

export default BrandMark
